import React, { useEffect } from 'react';
import './BalloonAnimation.css';

const BalloonAnimation = () => {
  useEffect(() => {
    const container = document.querySelector('.balloon-container');
    let interval = null;

    const createBalloon = () => {
      // Don't create if tab is not visible
      if (document.visibilityState !== 'visible') return;

      const isDesktop = window.innerWidth >= 768;
      const balloon = document.createElement('img');
      balloon.src = `/balloons/balloon${Math.ceil(Math.random() * 2)}.png`;
      balloon.className = 'balloon';

      const side = Math.random() < 0.5 ? 'left' : 'right';
      const leftPercent = isDesktop
        ? side === 'left'
          ? 5 + Math.random() * 5   // 5%–10%
          : 90 + Math.random() * 5  // 90%–95%
        : Math.random() * 100;       // full width for mobile

      balloon.style.left = `${leftPercent}%`;
      balloon.style.animationDuration = `${10 + Math.random() * 5}s`;

      container.appendChild(balloon);

      balloon.addEventListener('animationend', () => {
        if (container.contains(balloon)) {
          container.removeChild(balloon);
        }
      });
    };

    const startInterval = () => {
      if (!interval) {
        interval = setInterval(createBalloon, window.innerWidth < 768 ? 5000 : 3500);
      }
    };

    const stopInterval = () => {
      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        startInterval();
      } else {
        stopInterval();
      }
    };

    // Start on mount
    startInterval();

    // Pause/resume on visibility change
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      stopInterval();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return <div className="balloon-container"></div>;
};

export default BalloonAnimation;
